import * as Yup from "yup";

export const personalDataValidationSchema = Yup.object({
  name: Yup.string()
    .required("Nome completo é obrigatório.")
    .transform((value) => value.trim())
    .test(
      "no-special-characters",
      "Contém caracteres especiais ou números.",
      (value) => !value || /^[A-Za-zÀ-ÿàèìòùÃãÊêÕõ~\s]+$/.test(value)
    )
    .test("valid-full-name", "Insira pelo menos dois nomes.", (value) =>
      value ? value.trim().split(" ").length > 1 : false
    ),

  birthDate: Yup.string()
    .required("Data de nascimento é obrigatória")
    .matches(
      /^([0-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$/,
      "Data de nascimento inválida"
    )
    .test("valid-date", "Data de nascimento inválida", (value) => {
      if (!value) return false;
      const [day, month, year] = value.split("/").map(Number);
      const date = new Date(year, month - 1, day);
      if (
        !(
          date &&
          date.getDate() === day &&
          date.getMonth() === month - 1 &&
          date.getFullYear() === year
        )
      ) {
        return false;
      }
      const today = new Date();
      let age = today.getFullYear() - date.getFullYear();
      const monthDiff = today.getMonth() - date.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < date.getDate())
      ) {
        age--;
      }
      return age >= 18 && age <= 70;
    }),

  cellphone: Yup.string()
    .required("Celular é obrigatório")
    .matches(
      /^\(\d{2}\) \d{5}-\d{4}$/,
      "Formato inválido. Use (XX) XXXXX-XXXX"
    ),

  motherName: Yup.string()
    .required("Nome completo é obrigatório.")
    .transform((value) => value.trim())
    .test(
      "no-special-characters",
      "Contém caracteres especiais ou números.",
      (value) => !value || /^[A-Za-zÀ-ÿàèìòùÃãÊêÕõ~\s]+$/.test(value)
    )
    .test("valid-full-name", "Insira pelo menos dois nomes.", (value) =>
      value ? value.trim().split(" ").length > 1 : false
    ),
});

export const addressValidationSchema = Yup.object({
  street: Yup.string()
    .required("Rua é obrigatória")
    .matches(/^\S+\s+\S+.*$/, "A rua deve conter pelo menos duas palavras"),

  streetNumber: Yup.string()
    .required("Número é obrigatório")
    .matches(/^\d+$/, "O número deve conter apenas dígitos")
    .max(6, "O número deve ter no máximo 6 dígitos"),

  cep: Yup.string().required("CEP é obrigatório").min(9, "CEP precisa de 8 digitos"),
  district: Yup.string()
    .required("Bairro é obrigatório")
    .max(50, "Bairro não pode ter mais de 50 caracteres")
    .test(
      "no-special-characters",
      "Contém caracteres especiais ou números.",
      (value) => !value || /^[A-Za-zÀ-ÿàèìòùÃãÊêÕõ~\s]+$/.test(value)
    ),
  complement: Yup.string(),
  city: Yup.string()
    .required("Cidade é obrigatória")
    .test(
      "no-special-characters",
      "Contém caracteres especiais ou números.",
      (value) => !value || /^[A-Za-zÀ-ÿàèìòùÃãÊêÕõ~\s]+$/.test(value)
    ),
  state: Yup.string()
    .required("Estado é obrigatório")
    .max(2, "Estado não pode ter mais de 2 caracteres")
    .test(
      "no-special-characters",
      "Contém caracteres especiais ou números.",
      (value) => !value || /^[A-Za-zÀ-ÿàèìòùÃãÊêÕõ~\s]+$/.test(value)
    ),
});

export const bankDataValidationSchema = Yup.object().shape({
  pixType: Yup.string().nullable().required("Forma do Pix é obrigatória"),

  pixKey: Yup.string()
    .nullable()
    .when("pixType", {
      is: (value: string | null) => value !== "BANK_ACCOUNT" && value != null,
      then: (schema) => schema.required("Chave Pix é obrigatória"),
      otherwise: (schema) => schema.nullable(),
    }),

  accountType: Yup.string()
    .nullable()
    .when("pixType", {
      is: "BANK_ACCOUNT",
      then: (schema) => schema.required("Tipo de conta é obrigatório"),
      otherwise: (schema) => schema.nullable(),
    }),

  bankCode: Yup.string()
    .nullable()
    .when("pixType", {
      is: "BANK_ACCOUNT",
      then: (schema) => schema.required("Banco é obrigatório"),
      otherwise: (schema) => schema.nullable(),
    }),

  agency: Yup.string()
    .nullable()
    .when("pixType", {
      is: "BANK_ACCOUNT",
      then: (schema) =>
        schema
          .required("Agência é obrigatória")
          .matches(/^\d{4}$/, "Agência deve ter exatamente 4 dígitos")
          .typeError("Agência deve ser um número"),
      otherwise: (schema) => schema.nullable(),
    }),

  account: Yup.string()
    .nullable()
    .when("pixType", {
      is: "BANK_ACCOUNT",
      then: (schema) =>
        schema
          .required("Número da conta é obrigatório")
          .matches(/^\d+$/, "Número da conta deve conter apenas números")
          .max(11, "Número da conta deve ter no máximo 11 caracteres"),
      otherwise: (schema) => schema.nullable(),
    }),

  digit: Yup.string()
    .nullable()
    .when("pixType", {
      is: "BANK_ACCOUNT",
      then: (schema) => schema.required("Dígito é obrigatório"),
      otherwise: (schema) => schema.nullable(),
    }),
});
